import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { convertButtonProps } from "abreact/misc/AbButton";
import { AbDialogButtonBar as AbDialogButtonBarImpl } from "abreact/popup/AbDialogButtonBar";
import * as React from "react";

/**
 * Properties of the AbDialogButtonBar component.
 */

/**
 * The **AbDialogButtonBar** component is a container for displaying buttons, such as OK and Cancel, in an AbDialog component.
 *
 * [[include:absdk/commons/ui/popup/AbDialogButtonBar.md]]
 */
export class AbDialogButtonBar extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbDialogButtonBarImpl, _extends({}, this.props, {
      cancelButtonProps: convertButtonProps(this.props.cancelButtonProps),
      okButtonProps: convertButtonProps(this.props.okButtonProps)
    }));
  }
}
//# sourceMappingURL=AbDialogButtonBar.js.map
